export default __webpack_public_path__ + "static/media/coming-soon.f733b2e4.png";